import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PANES, ACTIONS } from '../constants/checkoutConstants';
import styles from './styles/CheckoutActions.scss';

// components
import EditAction from '../components/shared/CheckoutEditActionLink';
import DeleteAction from '../components/shared/CheckoutDeleteActionLink';
import CancelAction from '../components/shared/CheckoutCancelActionLink';

const ActionMap = {
    [ACTIONS.ACTION_EDIT]: EditAction,
    [ACTIONS.ACTION_DELETE]: DeleteAction,
    [ACTIONS.ACTION_CANCEL]: CancelAction,
};

export const CheckoutActions = ({ type, serviceId, actions, actionsWrapperClass }) => {
    const actionNames = Object.keys(actions);
    const actionLinks = actionNames.map(name => {
        const inputId = [type, serviceId, name].join('-');
        const Component = ActionMap[name];
        return (
            <li className={styles.item} key={name}>
                <Component
                    key={inputId}
                    type={type}
                    serviceId={serviceId}
                    onClick={actions[name]}
                />
            </li>
        );
    });
    const actionsWrapperClasses = classNames(styles.wrapper, {
        [actionsWrapperClass]: !!actionsWrapperClass,
    });

    return <ul className={actionsWrapperClasses}>{actionLinks}</ul>;
};

CheckoutActions.propTypes = {
    type: PropTypes.oneOf([PANES.PANE_SHIPPING, PANES.PANE_PAYMENT]).isRequired,
    serviceId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    actionsWrapperClass: PropTypes.string,
};
